export const getCustomer = /* GraphQL */ `
  query GetCustomer($id: ID!, $store: String!) {
    customer(id: $id, store: $store) {
      id
      orders {
        id
        name
        total {
          amount
          currency
        }
        createdAt
        fulfillments {
          id
          trackingNumber
          courierName
          shipmentStatus
          items {
            id
            title
            quantity
            price
            currency
          }
          trackingEvents {
            createdAt
            location
            message
          }
        }
        items {
          id
          title
          quantity
          price
          currency
        }
      }
    }
  }
`;

export const getOrders = /* GraphQL */ `
  query GetOrders(
    $customerAccessToken: String
    $customerId: String
    $first: Int
    $after: String
    $last: Int
    $before: String
    $query: String
  ) {
    orders(
      customerAccessToken: $customerAccessToken
      customerId: $customerId
      first: $first
      after: $after
      last: $last
      before: $before
      query: $query
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          name
          processedAt
          poNumber
          totalPriceSet {
            presentmentMoney {
              amount
              currencyCode
            }
          }
          lineItems {
            pageInfo {
              hasNextPage
              hasPreviousPage
              startCursor
              endCursor
            }
            edges {
              node {
                id
                title
                sku
                quantity
                discountedTotalSet {
                  presentmentMoney {
                    amount
                    currencyCode
                  }
                }
                originalUnitPriceSet {
                  presentmentMoney {
                    amount
                    currencyCode
                  }
                }
                currentQuantity
                image {
                  url
                  id
                }
                variant {
                  id
                  title
                  price
                  image {
                    id
                    url
                  }
                }
              }
            }
          }
          meta {
            shipments {
              allocationId
              fulfillmentOrderId
              events {
                timestamp
                description
                type
              }
              lineItems {
                id
                referenceId
                orderLineItemId
                events {
                  timestamp
                  description
                  type
                }
                info {
                  timestamp
                  description
                  type
                }
              }
            }
            pickupStatus
          }
          transactions {
            id
            gateway
            kind
            amountSet {
              presentmentMoney {
                amount
                currencyCode
              }
              shopMoney {
                amount
                currencyCode
              }
            }
            accountNumber
            paymentMethod
            paymentIcon {
              altText
              originalSrc
              src
              transformedSrc
              url
            }
          }
          fulfillments {
            trackingInfo {
              company
              number
              url
            }
          }
        }
        cursor
      }
    }
  }
`;

export const getOrder = /* GraphQL */ `
  query GetOrder($id: ID!, $customerAccessToken: String, $customerId: String) {
    order(
      customerAccessToken: $customerAccessToken
      id: $id
      customerId: $customerId
    ) {
      id
      refundable
      name
      currencyCode
      createdAt
      poNumber
      displayFinancialStatus
      shippingAddress {
        firstName
        lastName
        address1
        address2
        city
        province
        country
        zip
        company
        phone
      }
      totalPriceSet {
        presentmentMoney {
          amount
          currencyCode
        }
        shopMoney {
          amount
          currencyCode
        }
      }
      totalTaxSet {
        presentmentMoney {
          amount
          currencyCode
        }
        shopMoney {
          amount
          currencyCode
        }
      }
      currentTotalPriceSet {
        shopMoney {
          amount
          currencyCode
        }
        presentmentMoney {
          amount
          currencyCode
        }
      }
      currentTotalTaxSet {
        presentmentMoney {
          amount
          currencyCode
        }
        shopMoney {
          amount
          currencyCode
        }
      }
      currentSubtotalPriceSet {
        presentmentMoney {
          amount
          currencyCode
        }
        shopMoney {
          amount
          currencyCode
        }
      }
      totalRefundedShippingSet {
        shopMoney {
          amount
          currencyCode
        }
        presentmentMoney {
          amount
          currencyCode
        }
      }
      subtotalPriceSet {
        presentmentMoney {
          amount
          currencyCode
        }
        shopMoney {
          amount
          currencyCode
        }
      }
      totalShippingPriceSet {
        presentmentMoney {
          amount
          currencyCode
        }
        shopMoney {
          amount
          currencyCode
        }
      }
      meta {
        pickupStatus
        pickupAddress {
          address1
          address2
          city
          province
          phone
          zip
        }
        shipments {
          allocationId
          fulfillmentOrderId
          events {
            timestamp
            description
            type
          }
          lineItems {
            id
            referenceId
            orderLineItemId
            events {
              timestamp
              description
              type
            }
            info {
              timestamp
              description
              type
            }
          }
        }
      }
      lineItems {
        id
        title
        quantity
        discountedTotalSet {
          presentmentMoney {
            amount
            currencyCode
          }
        }
        originalUnitPriceSet {
          presentmentMoney {
            amount
            currencyCode
          }
        }
        currentQuantity
        image {
          id
          url
        }
        variant {
          id
          title
          price
        }
      }
      transactions {
        id
        gateway
        kind
        amountSet {
          presentmentMoney {
            amount
            currencyCode
          }
          shopMoney {
            amount
            currencyCode
          }
        }
        accountNumber
        paymentMethod
        paymentIcon {
          altText
          originalSrc
          src
          transformedSrc
          url
        }
      }
      unfulfilledLineItems {
        id
        title
        currentQuantity
        image {
          id
          url
        }
        discountedTotalSet {
          presentmentMoney {
            amount
            currencyCode
          }
        }
        originalUnitPriceSet {
          presentmentMoney {
            amount
            currencyCode
          }
        }
      }
      fulfilledLineItems {
        id
        name
        createdAt
        displayStatus
        trackingInfo {
          company
          number
          url
        }
        lineItems {
          id
          title
          currentQuantity
          image {
            id
            url
          }
          discountedTotalSet {
            presentmentMoney {
              amount
              currencyCode
            }
          }
          originalUnitPriceSet {
            presentmentMoney {
              amount
              currencyCode
            }
          }
        }
      }
    }
  }
`;

export const getOrderRefundable = /* GraphQL */ `
  query GetOrder($customerAccessToken: String!, $id: ID!) {
    order(customerAccessToken: $customerAccessToken, id: $id) {
      id
      refundable
    }
  }
`;

export const getCustomersOrder = `
query GetCustomerOrders($customerAccessToken: String!) {
  customer(customerAccessToken: $customerAccessToken) {
    id
    orders(first: 100) {
      edges {
        node {
          id
          name
          processedAt
          totalPriceV2 {
            amount
            currencyCode
          }
          financialStatus
          fulfillmentStatus
          shippingAddress{
            address1
            address2
            city
            country
            firstName
            lastName
            phone
            province
        }
          lineItems(first: 20) {
            edges {
              node {
                title
                quantity
                variant {
                  id
                  title
                  priceV2 {
                    amount
                    currencyCode
                  }
                  sku
                }
              }
            }
          }
        }
      }
    }
  }
}
`;

/* GraphQL Query */
export const getCustomerOrderDetails = `
query GetCustomerOrders($customerAccessToken: String!) {
  customer(customerAccessToken: $customerAccessToken) {
    id
    orders(first: 100) {
      edges {
        node {
          legacyId: id
          name
          processedAt
          totalPriceV2 {
            amount
            currencyCode
          }
          financialStatus
          fulfillmentStatus
          lineItems(first: 20) {
            edges {
              node {
                title
                quantity
                variant {
                  id
                  title
                  priceV2 {
                    amount
                    currencyCode
                  }
                  sku
                }
              }
            }
          }
        }
      }
    }
  }
}
`;

/**
 * Get Customer Details
 * Date: 2-August-2023
 */
// const GetCustomerDetails = `
// query {
//   customer(customerAccessToken: $customerAccessToken) {
//     id
//     firstName
//     lastName
//     acceptsMarketing
//     email
//     phone
//   }
// }`;

/**
 * Get Customer Details
 * Date: 2-August-2023
 */

export const GetCustomerDetails = `
query GetCustomer($customerAccessToken: String!) {
  customer(customerAccessToken: $customerAccessToken) {
    id
  }
}`;
